import { render } from "./TabsWrapperDynamic.vue?vue&type=template&id=022e9e5c"
import script from "./TabsWrapperDynamic.vue?vue&type=script&lang=js"
export * from "./TabsWrapperDynamic.vue?vue&type=script&lang=js"

import "./TabsWrapperDynamic.vue?vue&type=style&index=0&id=022e9e5c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__